export const ACTIVATE_CARD_BEGIN = 'ACTIVATE_CARD_BEGIN';
export const ACTIVATE_CARD_SUCCESS = 'ACTIVATE_CARD_SUCCESS';
export const ACTIVATE_CARD_FAILURE = 'ACTIVATE_CARD_FAILURE';

const activateCardSuccess = () => ({
  type: ACTIVATE_CARD_SUCCESS,
  payload: null,
});

const activateCardBegin = () => ({
  type: ACTIVATE_CARD_BEGIN,
});

const activateCardFailure = (error) => ({
  type: ACTIVATE_CARD_FAILURE,
  error: error.message,
});

export const activateCard = (cardNumber) => (dispatch) => {
  dispatch(activateCardBegin());
  const normalizedCardNumber = (cardNumber || '').replace(/ /g, '');
  const url = normalizedCardNumber
    ? `/api/cards/activate/${normalizedCardNumber}`
    : '/api/cards/activate';

  return fetch(url, {
    credentials: 'same-origin'
  })
    .then(response => handleErrors(response))
    .then(data => dispatch(activateCardSuccess(data)))
    .catch(err => {
      return dispatch(activateCardFailure(err));
    });
}

function handleErrors(response) {
  if (!response.ok) {
    return response.json().then(errorResponse => {
      const detail = errorResponse.detail || errorResponse.message;
      if (response.status === 404) {
        throw new Error(detail || 'Deze pas werd niet gevonden.');
      } else if (response.status === 403) {
        throw new Error(detail || 'U heeft geen toegang.');
      } else {
        throw new Error(detail || 'Er is een fout opgetreden.');
      }
    }).catch(err => {
      throw err;
    });
  }
  return response.json();
}